import * as React from "react";
import BaseModal, { BaseModalContent } from "../BaseModal";
//import PersonIcon from '@material-ui/icons/Person';
import AddAddressModalForm from "../../Forms/profile/AddAddressModalForm";
import { useDispatch, useSelector } from "react-redux";
import { getUserContextData } from "../../../store/login/selector";
import { getStates } from "../../../store/profile/action";
import { useParams } from "react-router";

const AddAddressModal=(props)=>{ 
    const {isOpenAddAddressModal,handleCloseAddAddressModal} = props;
    const user = useSelector(getUserContextData);
    const UserParams = useParams();
    const dispatch = useDispatch();
    React.useEffect(()=>{
        // dispatch(getStates(user && user.user.userName))
        dispatch(getStates(UserParams.customer));
    },[])
   
    return(
        <>
            <BaseModal
                title="Driver Account Address"
                align="center"
                open={isOpenAddAddressModal}
                onClose={handleCloseAddAddressModal}
                fullWidth
                className="modal-header"
            >
                <BaseModalContent>
                   <AddAddressModalForm handleClose={handleCloseAddAddressModal}/>
                </BaseModalContent>
            </BaseModal>
        </>
    )
}
export default AddAddressModal;